<template>
  <ion-modal
    animated
    showBackdrop
    css-class="custom-modal"
    :is-open="isOpened"
    @didDismiss="$emit('onClose')"
  >
    <div
      class="w-full h-full relative pt-20 bg-black flex justify-center items-center"
    >
      <div
        class="bg-black absolute top-0 left-0 flex px-8 w-full z-10"
        style="height:90px"
      >
        <!-- close button -->
        <ion-button
          type="button"
          class="relative mr-auto my-auto back-button"
          @click="closeVideo"
        >
          <ion-img
            src="/assets/button-icons/close-white.svg"
            className="pointer-events-none"
          />
        </ion-button>
      </div>
      <div class="w-full relative" style="padding-bottom:56.25%">
        <video
          v-if="isOpened && file && video?.url"
          :src="video.url"
          class="absolute w-full h-full"
          controls
          autoplay
          playsinline
        ></video>
        <iframe
          v-else-if="isOpened && videoEmbedUrl"
          :src="videoEmbedUrl"
          title="YouTube video player"
          class="absolute w-full h-full"
          frameborder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          sandbox="allow-scripts allow-same-origin allow-presentation"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </ion-modal>
</template>

<script>
import { IonImg, IonModal, IonButton } from '@ionic/vue'
import env from '@/env'

export default {
  components: {
    IonImg,
    IonModal,
    IonButton
  },

  props: {
    open: {
      type: Boolean
    },

    video: {
      type: Object
    },

    direct: {
      type: Boolean,
      default: false
    },

    code: {
      type: Boolean,
      default: false
    },

    // Native player for direct files: an iframe gives no reliable controls or fullscreen on iOS
    file: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isOpened: false
    }
  },

  methods: {
    closeVideo () {
      this.$emit('onClose')
    }
  },

  computed: {
    youtubeProxyBase () {
      return env.isProduction
        ? 'https://app.enovis-surgical.com'
        : 'https://app.staging.enovis-surgical.com'
    },

    videoEmbedUrl () {
      if (this.code) {
        return this.youtubeProxyBase + '/youtube.html?v=' + this.video.code
      }
      if (!this.direct) {
        const url = this?.video?.url
        if(!url) return ''
        const urlCodeArray = url?.split('/')
        const code = urlCodeArray[urlCodeArray?.length - 1]
        return this.youtubeProxyBase + '/youtube.html?v=' + code
      }
      return this.video?.url
    }
  },

  watch: {
    open: function (newValue) {
      this.isOpened = newValue
    }
  }
}
</script>
